export default __webpack_public_path__ + "static/media/stellung feuerhalt.10b48150.png";